import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BarChartModel } from './barchart.model';

@Component({
  selector: 'app-horizontal-bar-chart',
  templateUrl: './horizontal-bar-chart.component.html',
  styleUrls: ['./horizontal-bar-chart.component.css']
})
export class HorizontalBarChartComponent implements OnInit, OnChanges {

  @Input() data:BarChartModel = null;
  constructor() { }
  ngOnChanges(changes: SimpleChanges): void {
    if(changes && changes.data){
      // Plotly.redraw('chart');
    }
  }

  ngOnInit() {
    this.onDraw();
  }
  onDraw(){
    if(this.data){
      // Plotly.newPlot('chart', <any[]>this.data.data, <any>this.data.layout);
    }    
  }
}
